import {
    saveQualityRequirementsPolicySchema,
    SaveQualityRequirementsPolicyType,
} from '../../../schemas/qualityRequirementsPolicy.schemas';
import { baseResponseSchema, BaseResponseSchemaType } from '../../../schemas/repository.schemas';
import HttpReq from '../../../service/httpReq';
import { PathFactory } from '../utils';
import {
    qualityRequirementsPolicyListResponseSchema,
    QualityRequirementsPolicyListResponseType,
    qualityRequirementsPolicyResponseSchema,
    QualityRequirementsPolicyResponseType,
} from './schemas';

class QualityRequirementsPoliciesRepo {
    static managementPath = 'api/mgmt/quality-requirements-policies';

    static list(
        successConsumer: (response: QualityRequirementsPolicyListResponseType) => void,
        errorConsumer?: (...args: any[]) => void,
    ) {
        HttpReq.get(
            QualityRequirementsPoliciesRepo.managementPath,
            (response: unknown) => {
                successConsumer(qualityRequirementsPolicyListResponseSchema.parse(response));
            },
            errorConsumer,
        );
    }

    static create(
        spec: SaveQualityRequirementsPolicyType,
        successConsumer: (response: QualityRequirementsPolicyResponseType) => void,
        errorConsumer?: (...args: any[]) => void,
    ) {
        saveQualityRequirementsPolicySchema.parse(spec);
        HttpReq.post(
            QualityRequirementsPoliciesRepo.managementPath,
            spec,
            (response: unknown) => {
                successConsumer(qualityRequirementsPolicyResponseSchema.parse(response));
            },
            errorConsumer,
        );
    }

    static update(
        id: number,
        spec: SaveQualityRequirementsPolicyType,
        successConsumer: (response: QualityRequirementsPolicyResponseType) => void,
        errorConsumer?: (...args: any[]) => void,
    ) {
        saveQualityRequirementsPolicySchema.parse(spec);
        HttpReq.put(
            PathFactory.create([QualityRequirementsPoliciesRepo.managementPath, id]),
            spec,
            (response: unknown) => {
                successConsumer(qualityRequirementsPolicyResponseSchema.parse(response));
            },
            errorConsumer,
        );
    }

    static delete(
        id: number,
        successConsumer: (response: BaseResponseSchemaType) => void,
        errorConsumer?: (...args: any[]) => void,
    ) {
        HttpReq.delete(
            PathFactory.create([QualityRequirementsPoliciesRepo.managementPath, id]),
            (response: unknown) => {
                successConsumer(baseResponseSchema.parse(response));
            },
            errorConsumer,
        );
    }
}

export default QualityRequirementsPoliciesRepo;
